// extracted by mini-css-extract-plugin
module.exports = {"banner-wrapper":"HomeBannerText_banner-wrapper__xGwrU","banner-text":"HomeBannerText_banner-text__1BoyG","banner-subtext":"HomeBannerText_banner-subtext__H5XIZ"};